import { focusNext } from './ViewletTitleBarMenuBarFocusNext.js'

export const handleKeyArrowRightMenuClosed = focusNext
